<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <!-- <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
  <i class="pi pi-times" aria-hidden="true"></i>
</button>
<hr> -->
<div [formGroup]="form1" class="forms w-100 d-block propertyconfig-table">
  <div class="row m-0">
    @if (!showFields) {
      <div class="col-lg-2">
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;" (click)="syncPropertyByIdConfirmation()">Sync Property by Id</button>
      </div>
    }
    @if (!showFields) {
      <div class="col-lg-3">
        @if (propertyId) {
          <p-button class="btn-error-custom" [outlined]="true" severity="danger" (click)="yieldMaxDeleteAndRegenerateAllLosConfirmation(propertyId)">YieldMax DELETE AND REGENERATE ALL LOS for {{form1?.get('propertyCode')?.value}}</p-button>
        }
      </div>
    }
    @if (!showFields) {
      <div class="col-lg-1"></div>
    }
    <!-- <div *ngIf="!showFields" class="col-lg-5">
    <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;" (click)="syncReservationsByPropertyConfirmation()">Sync Reservations By Property</button>
  </div> -->
  @if (!showFields) {
    <div class="col-lg-3 mb-6 mt-3"></div>
  }

  @if (!showFields) {
    <div class="col-lg-12">
      @if (formAlert) {
        <div class="w-100 mb-3">
          <div class="w-100" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
            <p><b>{{formAlert}}</b></p>
          </div>
        </div>
      }
    </div>
  }

  @if (!showFields) {
    <div class="col-lg-3 borderadd">
      <span class="p-float-label w-100 mb-3">
        <input [readonly]="!showFields" formControlName="propertyCode" id="propertyCode" type="text" pInputText>
        <label for="propertyCode">Property Code</label>
        @for (validation of validationMessages.propertyCode; track validation) {
          <span>
            @if (form1.get('propertyCode').hasError(validation.type) && (form1.get('propertyCode').dirty || form1.get('propertyCode').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (!showFields) {
    <div class="col-lg-3 borderadd">
      <span class="p-float-label w-100 mb-3">
        <input [readonly]="!showFields" formControlName="propertyName" id="propertyName" type="text" pInputText>
        <label for="propertyName">Property Name</label>
        @for (validation of validationMessages.propertyName; track validation) {
          <span>
            @if (form1.get('propertyName').hasError(validation.type) && (form1.get('propertyName').dirty || form1.get('propertyName').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (!showFields) {
    <div class="col-lg-3 borderadd">
      <span class="p-float-label w-100 mb-3">
        <input [readonly]="!showFields" formControlName="developmentName" id="developmentName" type="text" pInputText>
        <label for="developmentName">Development Name</label>
        @for (validation of validationMessages.developmentName; track validation) {
          <span>
            @if (form1.get('developmentName').hasError(validation.type) && (form1.get('developmentName').dirty || form1.get('developmentName').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (!showFields) {
    <div class="col-lg-3 borderadd">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [readonly]="!showFields" class="w-100" [options]="statuses" formControlName="listingStatus" optionLabel="name" optionValue="value" placeholder="Status"></p-dropdown>
        <label for="Status">Status</label>
        @for (validation of validationMessages.listingStatus; track validation) {
          <span>
            @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (!showFields) {
    <div class="col-lg-3 borderadd mt-3">
      <span class="p-float-label w-100 mb-3">
        <!-- <input formControlName="propertyType" id="propertyType" type="text" pInputText> -->
        <p-dropdown [readonly]="!showFields" class="w-100" [options]="propertyTypes" formControlName="propertyType" optionLabel="name" optionValue="value" placeholder="Property Type"></p-dropdown>
        <label for="propertyType">Property Type</label>
        @for (validation of validationMessages.propertyType; track validation) {
          <span>
            @if (form1.get('propertyType').hasError(validation.type) && (form1.get('propertyType').dirty || form1.get('propertyType').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (showFields) {
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [readonly]="!showFields" class="w-100" [options]="rateBuckets" formControlName="rateBucketId" optionLabel="name" optionValue="rateBucketId" [filter]="true" filterBy="name"
        placeholder="Rate Bucket"></p-dropdown>
        <label for="Status">Rate Bucket</label>
        @for (validation of validationMessages.rateBucketId; track validation) {
          <span>
            @if (form1.get('rateBucketId').hasError(validation.type) && (form1.get('rateBucketId').dirty || form1.get('rateBucketId').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (showFields) {
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [readonly]="!showFields" class="w-100" [options]="occProfiles" formControlName="occProfileId" optionLabel="occProfileName" optionValue="occProfileId" [filter]="true" filterBy="occProfileName"
        placeholder="Occ Matrix Profile"></p-dropdown>
        <label for="Status">Occ Matrix Profile</label>
        @for (validation of validationMessages.occProfileId; track validation) {
          <span>
            @if (form1.get('occProfileId').hasError(validation.type) && (form1.get('occProfileId').dirty || form1.get('occProfileId').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (showFields) {
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [readonly]="!showFields" class="w-100" [options]="occMaps" formControlName="occMapId" optionLabel="name" optionValue="occMapId" [filter]="true" filterBy="name"
        placeholder="Occ Map"></p-dropdown>
        <label for="Status">Occ Map</label>
        @for (validation of validationMessages.occMapId; track validation) {
          <span>
            @if (form1.get('occMapId').hasError(validation.type) && (form1.get('occMapId').dirty || form1.get('occMapId').touched)) {
              <small class="p-invalid">{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }


  @if (showFields) {
    <div class="col-lg-3">
      @if (propertyId) {
        <p-button class="btn-error-custom" [outlined]="true" severity="danger" (click)="yieldMaxSurgicalDeleteRateLos(propertyId)">YieldMax Surgical Delete Rate LOS for {{form1?.get('propertyCode')?.value}}</p-button>
      }
    </div>
  }
  @if (showFields) {
    <div class="col-lg-3">
      @if (propertyId) {
        <p-button class="btn-error-custom" [outlined]="true" severity="danger" (click)="wikiSurgicalDeleteRateLos(form1?.get('extSystemId')?.value)">Wiki Surgical Delete Rate LOS for {{form1?.get('propertyCode')?.value}}</p-button>
      }
    </div>
  }

  <!-- <div *ngIf="!showFields" class="col-lg-6">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown class="w-100" [options]="rateBuckets" formControlName="rateBucketId" optionLabel="name"
    optionValue="rateBucketId" placeholder="Rate Bucket"></p-dropdown>
    <label for="Status">Rate Bucket</label>
    <span *ngFor="let validation of validationMessages.rateBucketId">
      <small class="p-invalid"
        *ngIf="form1.get('rateBucketId').hasError(validation.type) && (form1.get('rateBucketId').dirty || form1.get('rateBucketId').touched)">{{validation.message}}
      </small>
    </span>
  </span>
</div> -->

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <p-dropdown [readonly]="!showFields" class="w-100" [options]="statusType" formControlName="listingType" optionLabel="name" optionValue="value" placeholder="Listing Type"></p-dropdown>
      <label for="listingType">Listing Type</label>
      @for (validation of validationMessages.listingType; track validation) {
        <span>
          @if (form1.get('listingType').hasError(validation.type) && (form1.get('listingType').dirty || form1.get('listingType').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <h6 class="pt-3">Address</h6>
}
@if (!showFields) {
  <div class="col-lg-12 borderadd">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrStreet" id="adrStreet" type="text" pInputText>
      <label for="adrStreet">Address Street</label>
      @for (validation of validationMessages.adrStreet; track validation) {
        <span>
          @if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-12 borderadd">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrStreet2" id="adrStreet2" type="text" pInputText>
      <label for="adrStreet2">Address Street2</label>
      @for (validation of validationMessages.adrStreet2; track validation) {
        <span>
          @if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrUnit" id="adrUnit" type="text" pInputText>
      <label for="adrUnit">Unit</label>
      @for (validation of validationMessages.adrUnit; track validation) {
        <span>
          @if (form1.get('adrUnit').hasError(validation.type) && (form1.get('adrUnit').dirty || form1.get('adrUnit').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrBuilding" id="adrBuilding" type="text" pInputText>
      <label for="adrBuilding">Building</label>
      @for (validation of validationMessages.adrBuilding; track validation) {
        <span>
          @if (form1.get('adrBuilding').hasError(validation.type) && (form1.get('adrBuilding').dirty || form1.get('adrBuilding').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrComplex" id="adrComplex" type="text" pInputText>
      <label for="adrComplex">Complex</label>
      @for (validation of validationMessages.adrComplex; track validation) {
        <span>
          @if (form1.get('adrComplex').hasError(validation.type) && (form1.get('adrComplex').dirty || form1.get('adrComplex').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}


@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrDistrict" id="adrDistrict" type="text" pInputText>
      <label for="adrDistrict">District</label>
      @for (validation of validationMessages.adrDistrict; track validation) {
        <span>
          @if (form1.get('adrDistrict').hasError(validation.type) && (form1.get('adrDistrict').dirty || form1.get('adrDistrict').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}
@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrCounty" id="adrCounty" type="text" pInputText>
      <label for="adrCounty">County</label>
      @for (validation of validationMessages.adrCounty; track validation) {
        <span>
          @if (form1.get('adrCounty').hasError(validation.type) && (form1.get('adrCounty').dirty || form1.get('adrCounty').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}
@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrMetro" id="adrMetro" type="text" pInputText>
      <label for="adrMetro">Metro</label>
      @for (validation of validationMessages.adrMetro; track validation) {
        <span>
          @if (form1.get('adrMetro').hasError(validation.type) && (form1.get('adrMetro').dirty || form1.get('adrMetro').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="crossStreet" id="crossStreet" type="text" pInputText>
      <label for="crossStreet">Cross Street</label>
      @for (validation of validationMessages.crossStreet; track validation) {
        <span>
          @if (form1.get('crossStreet').hasError(validation.type) && (form1.get('crossStreet').dirty || form1.get('crossStreet').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrRegion" id="adrRegion" type="text" pInputText>
      <label for="adrRegion">Region</label>
      @for (validation of validationMessages.adrRegion; track validation) {
        <span>
          @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty || form1.get('adrRegion').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}
@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrIsland" id="adrIsland" type="text" pInputText>
      <label for="adrIsland">Island</label>
      @for (validation of validationMessages.adrIsland; track validation) {
        <span>
          @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty || form1.get('adrIsland').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}


@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrCity" id="adrCity" type="text" pInputText>
      <label for="adrCity">City</label>
      @for (validation of validationMessages.adrCity; track validation) {
        <span>
          @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <p-dropdown [readonly]="!showFields" [options]="states" formControlName="adrState" optionLabel="name" appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
        placeholder="State">
      </p-dropdown>
      <label for="adrState">State</label>
      @for (validation of validationMessages.adrState; track validation) {
        <span>
          @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <p-dropdown [readonly]="!showFields" [options]="countries" formControlName="adrCountry" optionLabel="name" appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
        placeholder="Country">
      </p-dropdown>
      <label for="adrCountry">Country</label>
      @for (validation of validationMessages.adrCountry; track validation) {
        <span>
          @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="adrPostCode" id="adrPostCode" type="text" pInputText>
      <label for="adrPostCode">Postal Code</label>
      @for (validation of validationMessages.adrPostCode; track validation) {
        <span>
          @if (form1.get('adrPostCode').hasError(validation.type) && (form1.get('adrPostCode').dirty || form1.get('adrPostCode').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}





@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="longitude" id="longitude" type="text" pInputText>
      <label for="longitude">Longitude</label>
      @for (validation of validationMessages.longitude; track validation) {
        <span>
          @if (form1.get('longitude').hasError(validation.type) && (form1.get('longitude').dirty || form1.get('longitude').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}
@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="latitude" id="latitude" type="text" pInputText>
      <label for="latitude">Latitude</label>
      @for (validation of validationMessages.latitude; track validation) {
        <span>
          @if (form1.get('latitude').hasError(validation.type) && (form1.get('latitude').dirty || form1.get('latitude').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}


<h6 class="pt-3 mb-0">Property Details</h6>

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="websiteURL" id="websiteURL" type="text" pInputText>
      <label for="websiteURL">Website URL</label>
      @for (validation of validationMessages.websiteURL; track validation) {
        <span>
          @if (form1.get('websiteURL').hasError(validation.type) && (form1.get('websiteURL').dirty || form1.get('websiteURL').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="locale" id="locale" type="text" pInputText>
      <label for="locale">Locale</label>
      @for (validation of validationMessages.locale; track validation) {
        <span>
          @if (form1.get('locale').hasError(validation.type) && (form1.get('locale').dirty || form1.get('locale').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="yearBuilt" id="yearBuilt" type="text" pInputText>
      <label for="yearBuilt">Year Built</label>
      @for (validation of validationMessages.yearBuilt; track validation) {
        <span>
          @if (form1.get('yearBuilt').hasError(validation.type) && (form1.get('yearBuilt').dirty || form1.get('yearBuilt').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="floorOfProperty" id="floorOfProperty" type="text" pInputText>
      <label for="floorOfProperty">Floor Of Property</label>
      @for (validation of validationMessages.floorOfProperty; track validation) {
        <span>
          @if (form1.get('floorOfProperty').hasError(validation.type) && (form1.get('floorOfProperty').dirty || form1.get('floorOfProperty').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="floorsInBuilding" id="floorsInBuilding" type="text" pInputText>
      <label for="floorsInBuilding">Floors In Building</label>
      @for (validation of validationMessages.floorsInBuilding; track validation) {
        <span>
          @if (form1.get('floorsInBuilding').hasError(validation.type) && (form1.get('floorsInBuilding').dirty || form1.get('floorsInBuilding').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="sizeInterior" id="sizeInterior" type="text" pInputText>
      <label for="sizeInterior">Size Interior</label>
      @for (validation of validationMessages.sizeInterior; track validation) {
        <span>
          @if (form1.get('sizeInterior').hasError(validation.type) && (form1.get('sizeInterior').dirty || form1.get('sizeInterior').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="sizeExterior" id="sizeExterior" type="text" pInputText>
      <label for="sizeExterior">Size Exterior</label>
      @for (validation of validationMessages.sizeExterior; track validation) {
        <span>
          @if (form1.get('sizeExterior').hasError(validation.type) && (form1.get('sizeExterior').dirty || form1.get('sizeExterior').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="sizeUnit" id="sizeUnit" type="text" pInputText>
      <label for="sizeUnit">Size Unit</label>
      @for (validation of validationMessages.sizeUnit; track validation) {
        <span>
          @if (form1.get('sizeUnit').hasError(validation.type) && (form1.get('sizeUnit').dirty || form1.get('sizeUnit').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="numBedrooms" id="numBedrooms" type="text" pInputText>
      <label for="numBedrooms">Number Of Bedrooms</label>
      @for (validation of validationMessages.numBedrooms; track validation) {
        <span>
          @if (form1.get('numBedrooms').hasError(validation.type) && (form1.get('numBedrooms').dirty || form1.get('numBedrooms').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="numBathrooms" id="numBathrooms" type="text" pInputText>
      <label for="numBathrooms">Number Of Bathrooms</label>
      @for (validation of validationMessages.numBathrooms; track validation) {
        <span>
          @if (form1.get('numBathrooms').hasError(validation.type) && (form1.get('numBathrooms').dirty || form1.get('numBathrooms').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="sleepsMax" id="sleepsMax" type="text" pInputText>
      <label for="sleepsMax">Sleeps Max</label>
      @for (validation of validationMessages.sleepsMax; track validation) {
        <span>
          @if (form1.get('sleepsMax').hasError(validation.type) && (form1.get('sleepsMax').dirty || form1.get('sleepsMax').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="sleepsMaxInBeds" id="sleepsMaxInBeds" type="text" pInputText>
      <label for="sleepsMaxInBeds">Sleeps Max In Beds</label>
      @for (validation of validationMessages.sleepsMaxInBeds; track validation) {
        <span>
          @if (form1.get('sleepsMaxInBeds').hasError(validation.type) && (form1.get('sleepsMaxInBeds').dirty || form1.get('sleepsMaxInBeds').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="hotelRoomType" id="hotelRoomType" type="text" pInputText>
      <label for="hotelRoomType">Hotel Room Type</label>
      @for (validation of validationMessages.hotelRoomType; track validation) {
        <span>
          @if (form1.get('hotelRoomType').hasError(validation.type) && (form1.get('hotelRoomType').dirty || form1.get('hotelRoomType').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 borderadd mt-3">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="mgmtCommissionPct" id="mgmtCommissionPct" type="text" pInputText>
      <label for="mgmtCommissionPct">Mgmt Commission Pct</label>
      @for (validation of validationMessages.mgmtCommissionPct; track validation) {
        <span>
          @if (form1.get('mgmtCommissionPct').hasError(validation.type) && (form1.get('mgmtCommissionPct').dirty || form1.get('mgmtCommissionPct').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <p-inputNumber [readonly]="!showFields" class="w-100 eap-input" formControlName="maxNightlyRate" id="maxNightlyRate" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="maxNightlyRate">maxNightlyRate</label>
      @for (validation of validationMessages.maxNightlyRate; track validation) {
        <span>
          @if (form1.get('maxNightlyRate').hasError(validation.type) && (form1.get('maxNightlyRate').dirty || form1.get('maxNightlyRate').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-4">
    <span class="p-float-label w-100 mb-3">
      <p-inputNumber [readonly]="!showFields" class="w-100 eap-input" formControlName="minNightlyRate" id="minNightlyRate" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="minNightlyRate">Min Nightly Rate</label>
      @for (validation of validationMessages.minNightlyRate; track validation) {
        <span>
          @if (form1.get('minNightlyRate').hasError(validation.type) && (form1.get('minNightlyRate').dirty || form1.get('minNightlyRate').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-2">
    <span class="w-100 mb-3">
      <p-checkbox [formControl]="form1.controls['ownerEnforced']" inputId="ownerEnforced" [binary]="true"></p-checkbox>
      <label for="ownerEnforced">Owner Enforced</label>
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="minLengthOfStay" id="minLengthOfStay" type="text" pInputText>
      <label for="minLengthOfStay">Min Length Of Stay</label>
      @for (validation of validationMessages.minLengthOfStay; track validation) {
        <span>
          @if (form1.get('minLengthOfStay').hasError(validation.type) && (form1.get('minLengthOfStay').dirty || form1.get('minLengthOfStay').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="maxLengthOfStay" id="maxLengthOfStay" type="text" pInputText>
      <label for="maxLengthOfStay">Max Length Of Stay</label>
      @for (validation of validationMessages.maxLengthOfStay; track validation) {
        <span>
          @if (form1.get('maxLengthOfStay').hasError(validation.type) && (form1.get('maxLengthOfStay').dirty || form1.get('maxLengthOfStay').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <p-inputNumber [readonly]="!showFields" class="w-100 eap-input" formControlName="annualRevTargetAmnt" id="annualRevTargetAmnt" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="annualRevTargetAmnt">Annual Rev Target Amnt</label>
      @for (validation of validationMessages.annualRevTargetAmnt; track validation) {
        <span>
          @if (form1.get('annualRevTargetAmnt').hasError(validation.type) && (form1.get('annualRevTargetAmnt').dirty || form1.get('annualRevTargetAmnt').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (showFields) {
  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="rateBucketAdjustmentPct" id="rateBucketAdjustmentPct" type="text" pInputText>
      <label for="rateBucketAdjustmentPct">Rate Bucket Adjustment Pct</label>
      @for (validation of validationMessages.rateBucketAdjustmentPct; track validation) {
        <span>
          @if (form1.get('rateBucketAdjustmentPct').hasError(validation.type) && (form1.get('rateBucketAdjustmentPct').dirty || form1.get('rateBucketAdjustmentPct').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

@if (!showFields) {
  <div class="col-lg-3 mt-3 borderadd">
    <span class="p-float-label w-100 mb-3">
      <input [readonly]="!showFields" formControlName="vrboId" id="vrboId" type="text" pInputText>
      <label for="vrboId">VrboId</label>
      @for (validation of validationMessages.vrboId; track validation) {
        <span>
          @if (form1.get('vrboId').hasError(validation.type) && (form1.get('vrboId').dirty || form1.get('vrboId').touched)) {
            <small class="p-invalid">{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}

<div class="col-lg-6 borderadd mt-3">
  <span class="p-float-label w-100 mb-3">
    <input [readonly]=true formControlName="extSystemId" id="extSystemId" type="text" pInputText>
    <label for="extSystemId">External System Id</label>
    @for (validation of validationMessages.extSystemId; track validation) {
      <span>
        @if (form1.get('extSystemId').hasError(validation.type) && (form1.get('extSystemId').dirty || form1.get('extSystemId').touched)) {
          <small class="p-invalid">{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>

<div class="col-lg-6 borderadd mt-3">
  <span class="p-float-label w-100 mb-3">
    <input [readonly]=true formControlName="extSystemName" id="extSystemName" type="text" pInputText>
    <label for="extSystemName">External System Name</label>
    @for (validation of validationMessages.extSystemName; track validation) {
      <span>
        @if (form1.get('extSystemName').hasError(validation.type) && (form1.get('extSystemName').dirty || form1.get('extSystemName').touched)) {
          <small class="p-invalid">{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>
@if (showFields) {
  <div class="col-lg-6">
    <a href="https://www.kbmresorts.com/vacation-rentals/{{form1.value.extSystemId}}" style="color: rgb(0, 0, 255);" target="_blank">Public Website
    </a>
  </div>
}





</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          <!-- <button pButton *ngIf="propertyId" class="btn-delete p-button-outlined p-button-danger"
        (click)="onFormDelete()">Delete</button> -->
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        @if (!propertyId) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
        }
        <!-- <button pButton *ngIf="propertyId" class="btn-upt p-button" (click)="generateRate(propertyId)">Generate
      Rate for THIS PROPERTY</button> -->
      @if (propertyId && showFields) {
        <p-button class="btn-warning-custom" [outlined]="true" severity="danger" (click)="generateRate(propertyId)">Generate Rate for {{form1?.get('propertyCode')?.value}}</p-button>
      }
      <!--<button pButton *ngIf="propertyId" class="btn-upt p-button" (click)="generateRateLos(propertyId)">Generate Rate
    LOS</button>-->
    @if (propertyId && showFields) {
      <button pButton class="btn-upt p-button" (click)="formUpdate()">Update</button>
    }
  </div>
</div>
</div>
</div>